export const STATUS = Object.freeze({
    NOT_STARTED: 'NOT_STARTED',
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR'
})